export default {
  // a namespace is required by i18next
  forgot_password: {
    title: 'Forgot password?',
    details: 'Enter the email address associated with your account, and we’ll email you a link to reset your password.',
    resetLink: 'Send reset link',
    resetLinkSent: {
      title: 'Reset password link sent',
      details: '<p>If you have an account in our system, we have sent a link to reset your password to <strong>{email}</strong>.</p><p>If you don\'t see it shortly, please check your spam folder.</p>'
    },
    email: {
      placeholder: 'Email'
    },
    general: {
      back: 'Back to Login'
    }
  }
};
